import { AgentMerchantRoleDomain } from "./agent-merchant-role-domain";

export class AgentMerchantDomain {
  id: number;

  name: string;

  logo: string;

  role: AgentMerchantRoleDomain;

  isActive: boolean;

  rotationEnabled: boolean;

  constructor(
    id: number,
    name: string,
    logo: string,
    role: AgentMerchantRoleDomain,
    isActive: boolean,
    rotationEnabled: boolean
  ) {
    this.id = id;
    this.name = name;
    this.logo = logo;
    this.role = role;
    this.isActive = isActive;
    this.rotationEnabled = rotationEnabled;
  }

  public static sortMerchantsAlphabetically(
    a: AgentMerchantDomain,
    b: AgentMerchantDomain
  ) {
    return a.name.localeCompare(b.name);
  }

  getGroupName(): string {
    if (!this.name.includes("|")) {
      return "";
    }

    return this.name.split("|")[0].trim();
  }

  getNameWithoutGroup(): string {
    return this.name.split("|").slice(1).join("|").trim();
  }
}
